/**
 * URL pública de una imagen o archivo de leiten.com.ar.
 *
 * La API devuelve rutas tipo "public/productos/x.png" y el storage se sirve en
 * "storage/". Esto estaba escrito de dos formas distintas repartidas en cinco
 * archivos; ahora hay un solo lugar donde corregirlo si cambia el hosting.
 */
const STORAGE_BASE = 'https://leiten.com.ar/storage';

export function assetUrl(path) {
    if (!path) return null;
    return `${STORAGE_BASE}/${path.replace(/^public\//, '')}`;
}
